import { render, staticRenderFns } from "./VariationModal.vue?vue&type=template&id=18bb97c0&scoped=true&"
import script from "./VariationModal.vue?vue&type=script&lang=js&"
export * from "./VariationModal.vue?vue&type=script&lang=js&"
import style0 from "./VariationModal.vue?vue&type=style&index=0&id=18bb97c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb97c0",
  null
  
)

export default component.exports